export default __webpack_public_path__ + "static/7-fc454f4e81f4fc62306cbfd3e0168578.jpg";